import React from "react";
import TopDisclaimerBar from "./TopDisclaimerBar";
import Header from "./Header";
import Footer from "./Footer";
import { useI18n } from "../i18n";

export default function Layout({ pageKey, children }) {
  const { d } = useI18n();
  return (
    <div className="App noise-bg min-h-screen flex flex-col bg-jlo-bg">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:top-2 focus:left-2 focus:bg-jlo-gold focus:text-jlo-bg focus:px-4 focus:py-2 focus:rounded"
      >
        {d.ui.skipToContent}
      </a>
      <div className="sticky top-0 z-40">
        <TopDisclaimerBar />
        <Header pageKey={pageKey} />
      </div>
      <main id="main" className="relative z-10 flex-1">
        {children}
      </main>
      <Footer pageKey={pageKey} />
    </div>
  );
}
